<template>
  <div class="pagination">
    <el-row type="flex" justify="space-between">
      <div class="left">
        <el-select
          v-show="select"
          v-model="page.per"
          placeholder="Please Select"
          @change="handleSizeChange"
        >
          <el-option
            v-for="item in select_size_arr"
            :key="item"
            :label="item"
            :value="item"
          ></el-option>
        </el-select>
        <span class="select-label">Records per page</span>
      </div>
      <div class="right">
        <el-pagination
          @current-change="handleCurrentChange"
          :page-size.sync="page.per"
          :current-page.sync="page.cur"
          layout="prev, pager, next"
          :total="page.tot"
        ></el-pagination>
      </div>
    </el-row>
  </div>
</template>

<script>
export default {
  data() {
    return {
      select_size_arr: [10, 15, 25, 50, 100],
    }
  },
  props: {
    page: {
      type: Object,
      default() {
        return {
          tot: 0,
          per: 10,
          cur: 1,
        }
      },
    },
    select: {
      type: Boolean,
      default() {
        return true
      },
    },
  },
  created() {},
  methods: {
    handleSizeChange(val) {
      this.$emit('sizeChange', val)
    },
    handleCurrentChange(val) {
      this.$emit('currentChange', val)
    },
  },
}
</script>

<style scoped>
.pagination {
  position: absolute;
  bottom: 30px;
  left: 0;
  width: 100%;
}

.left {
  margin-left: 28px;
}
.right {
  margin-right: 28px;
}
.el-select {
  width: 22%;
  margin-right: 8px;
}
.select-label {
  font-size: 14px;
  font-weight: 400;
  color: rgba(199, 203, 210, 1);
}
</style>
